import React from 'react';
import Select, { components, OptionProps } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SelectOption } from '../../../types/ViewModel/SelectOption';
import { FutureActiveMarker, VesselOptionContent, VesselOptionLabel } from './SelectVessel.styles';

interface VesselSelectOption extends SelectOption {
    isActive: boolean;
    isFutureActive: boolean;
}

interface VesselSelectorVessel {
    imoNumber: number;
    vesselName: string;
    isActive: boolean;
    isFutureActive: boolean;
}

type Props = {
    onChange: (ev: any) => void;
    vesselList: VesselSelectorVessel[];
    selectedVessel: VesselSelectorVessel | null;
    width: string;
    height?: string;
};

const VesselOption = (optionProps: OptionProps<VesselSelectOption, false>) => {
    return (
        <components.Option {...optionProps}>
            <VesselOptionContent>
                <VesselOptionLabel>{optionProps.label}</VesselOptionLabel>
                {optionProps.data.isFutureActive === true && (
                    <FutureActiveMarker title="Not yet activated" role="img" aria-label="Not yet activated">
                        <FontAwesomeIcon icon="hourglass" aria-hidden="true" />
                    </FutureActiveMarker>
                )}
            </VesselOptionContent>
        </components.Option>
    );
};

const SelectVesselComponent: React.FC<Props> = (props) => {
    const mappedOptions = (): VesselSelectOption[] => {
        const vList: VesselSelectOption[] = props.vesselList.map((v) => {
            return {
                value: v.imoNumber.toString(),
                label: v.vesselName,
                isActive: v.isActive,
                isFutureActive: v.isFutureActive === true,
            };
        });
        return vList.sort((a, b) => a.label.localeCompare(b.label));
    };

    const mappedSelectedShip = (): VesselSelectOption | null => {
        if (props.selectedVessel) {
            return {
                value: props.selectedVessel.imoNumber.toString(),
                label: props.selectedVessel.vesselName,
                isActive: props.selectedVessel.isActive,
                isFutureActive: props.selectedVessel.isFutureActive === true,
            };
        }
        return null;
    };

    const styles = {
        control: (css) => ({
            ...css,
            display: 'inline-flex',
            width: props.width,
            minHeight: props.height ? props.height : '38px',
            height: props.height ? props.height : 'auto',
        }),
    };

    return (
        <Select
            components={{ Option: VesselOption }}
            className="select-container"
            value={mappedSelectedShip()}
            options={mappedOptions()}
            onChange={props.onChange}
            styles={styles}
            isSearchable={true}
            classNamePrefix="react-select"
        />
    );
};

export default SelectVesselComponent;
